export const CART_ACTIONS = {
  ADD_TO_CART: "ADD_TO_CART",
  SHOW_CART_ITEMS: "SHOW_CART_ITEMS",
  DELETE_CART_ITEMS: "DELETE_CART_ITEMS",
  UPDATE_CART_QTY: "UPDATE_CART_QTY",
  CLEAR_CART: "CLEAR_CART",
};
